export function getFieldSuggestionsOrderInitialState() {
    return [];
}
